export default __webpack_public_path__ + "static/media/LogoMain.2a532264.png";